import { Component, Directive, HostBinding, Input } from '@angular/core';
import { HelpSideDrawerTemplateRefService } from '../help-side-drawer-template-ref.service';

@Directive({
  selector: 'app-help-side-drawer-content, [app-help-side-drawer-content], [appHelpSideDrawerContent]',
  standalone: false,
})
export class HelpSideDrawerContentDirective {
  @HostBinding('class') className = 'help-side-drawer-content';
}

@Directive({
  selector: 'app-help-side-drawer-footer, [app-help-side-drawer-footer], [appHelpSideDrawerFooter]',
  standalone: false,
})
export class HelpSideDrawerFooterDirective {
  @HostBinding('class') className = 'help-side-drawer-footer';
}

@Directive({
  selector:
    'app-help-side-drawer-pre-title-actions, [app-help-side-drawer-pre-title-actions], [appHelpSideDrawerPreTitleActions]',
  standalone: false,
})
export class HelpSideDrawerPreTitleActionsDirective {
  @HostBinding('class') className = 'help-side-drawer-pre-title-actions';
}

@Directive({
  selector: 'app-help-side-drawer-title-actions, [app-help-side-drawer-title-actions], [appHelpSideDrawerTitleActions]',
  standalone: false,
})
export class HelpSideDrawerTitleActionsDirective {
  @HostBinding('class') className = 'help-side-drawer-title-actions';
}

@Component({
  selector: 'app-help-closing-side-drawer',
  templateUrl: './help-closing-side-drawer.component.html',
  styleUrls: ['./help-closing-side-drawer.component.scss'],
  standalone: false,
})
export class HelpClosingSideDrawerComponent {
  @Input()
  title: string;

  @Input()
  preventClose: boolean;

  constructor(private readonly helpSideDrawerTemplateRefService: HelpSideDrawerTemplateRefService) {}

  closeSideDrawer(): void {
    this.helpSideDrawerTemplateRefService.close();
  }
}
